<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>内部管理</el-breadcrumb-item>
      <el-breadcrumb-item>控股集团官网</el-breadcrumb-item>
      <el-breadcrumb-item>产品管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 查询用户 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-select v-model="keywords.categories" placeholder="请选择" class="select"  style="width: 200px;">
               <el-option
                 v-for="item in categoriesList" :key="item.value" :label="item.label" :value="item.value">
               </el-option>
             </el-select>
            </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.name" @keyup.enter.native="clicksearch" placeholder="请输入产品名称" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 查询用户 end -->

        <el-table :data="dataList" border stripe >
          <el-table-column prop="Listorder" label="排序" min-width="3%"></el-table-column>
          <el-table-column prop="Id" label="编号" min-width="3%"></el-table-column>
          <el-table-column prop="Categories" label="产品分类" min-width="5%"></el-table-column>
          <el-table-column prop="Name" label="产品名称" min-width="12%"></el-table-column>
          <el-table-column prop="Introduction" label="产品简介" min-width="25%"></el-table-column>
          <el-table-column prop="Price" label="产品价格" min-width="5%"></el-table-column>
          <!-- <el-table-column prop="Freedelivery" label="包邮起始数量" min-width="7%"></el-table-column> -->
          <el-table-column prop="Isstars" label="是否明星产品" min-width="7%"></el-table-column>
          <el-table-column prop="Isrecommendeds" label="是否爆款推荐" min-width="7%"></el-table-column>
<!--          <el-table-column prop="Isbests" label="是否畅销产品" min-width="7%"></el-table-column>
          <el-table-column prop="Isfirsts" label="是否首页首推" min-width="7%"></el-table-column> -->
          <el-table-column label="操作" min-width="15%">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="goEdit(scope.row)">修改</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="goDel(scope.row)">删除</el-button>
              <!-- <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="goCharacteristics(scope.row)">产品特点</el-button> -->
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="goColor(scope.row)">产品颜色</el-button>
              <!-- <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="goInfo(scope.row,1)">免费服务</el-button> -->
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="goInfo(scope.row,2)">包装</el-button>
              <!-- <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="goInfo(scope.row,3)">售后服务1</el-button> -->
              <!-- <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="goInfo(scope.row,4)">售后服务2</el-button> -->
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="goInfo(scope.row,5)">产品信息</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="goRecommend(scope.row)">为你推荐</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

      <!-- 添加 start -->
      <el-tab-pane label="添加">
        <el-form :model="addData" ref="addDataRef" label-width="110px">
          <el-form-item label="产品分类">
            <el-select v-model="addData.categories" placeholder="请选择" class="select">
              <el-option
                v-for="item in categoriesList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品名称" class="addAdminForm">
            <el-input v-model="addData.name" placeholder="请输入产品名称"></el-input>
          </el-form-item>
          <el-form-item label="产品简介" class="addAdminForm">
            <el-input v-model="addData.introduction" type="textarea" :rows="5" placeholder="请输入产品简介"></el-input>
          </el-form-item>
          <el-form-item label="产品价格" class="addAdminForm">
            <el-input v-model="addData.price" placeholder="请输入产品价格"></el-input>
          </el-form-item>
          <el-form-item label="明星产品缩略图" class="addAdminForm">
            <el-input v-model="addData.thumbnail1" placeholder="用于明星产品显示"></el-input>
          </el-form-item>
          <el-form-item label="通用产品缩略图" class="addAdminForm">
            <el-input v-model="addData.thumbnail2" placeholder="用于通用产品显示"></el-input>
          </el-form-item>
          <el-form-item label="产品详情图" class="addAdminForm">
            <el-input v-model="addData.details" placeholder="产品详情图片"></el-input>
          </el-form-item>
          <el-form-item label="是否明星产品">
            <el-select v-model="addData.isstar" placeholder="请选择" class="select">
              <el-option
                v-for="item in isStarList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否爆款推荐">
            <el-select v-model="addData.isrecommended" placeholder="请选择" class="select">
              <el-option
                v-for="item in isRecommendedList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
<!--          <el-form-item label="是否畅销产品">
            <el-select v-model="addData.isbest" placeholder="请选择" class="select">
              <el-option
                v-for="item in isList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item> -->
<!--          <el-form-item label="是否首页首推">
            <el-select v-model="addData.isfirst" placeholder="请选择" class="select">
              <el-option
                v-for="item in isFirstList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item class="mt20">
            <el-button type="primary" @click="clickadd">添加</el-button>
            <el-button type="info" @click="BackToFirst">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 添加 end -->

      <el-tab-pane label="修改" name="second" disabled="disabled">
        <KgjtWebsiteProductEdit ref="SubVuesecond" v-on:triggerFunc="BackToFirst"></KgjtWebsiteProductEdit>
      </el-tab-pane>

<!--      <el-tab-pane label="产品特点" name="three" disabled="disabled">
        <KgjtWebsiteProductCharacteristics ref="SubVuethree" v-on:triggerFunc="BackToFirst"></KgjtWebsiteProductCharacteristics>
      </el-tab-pane> -->

      <el-tab-pane label="产品颜色" name="four" disabled="disabled">
        <KgjtWebsiteProductColor ref="SubVuefour" v-on:triggerFunc="BackToFirst"></KgjtWebsiteProductColor>
      </el-tab-pane>

     <el-tab-pane label="产品辅助信息" name="five" disabled="disabled">
        <KgjtWebsiteProductInfo ref="SubVuefive" v-on:triggerFunc="BackToFirst"></KgjtWebsiteProductInfo>
      </el-tab-pane>

      <el-tab-pane label="为你推荐" name="six" disabled="disabled">
        <KgjtWebsiteProductRecommend ref="SubVuesix" v-on:triggerFunc="BackToFirst"></KgjtWebsiteProductRecommend>
      </el-tab-pane>

    </el-tabs>
    <!-- Tabs end -->
  </div>
</template>

<script>
import KgjtWebsiteProductEdit from '@/componentsKgjt/KgjtWebsiteProductEdit.vue'
import KgjtWebsiteProductCharacteristics from '@/componentsKgjt/KgjtWebsiteProductCharacteristics.vue'
import KgjtWebsiteProductColor from '@/componentsKgjt/KgjtWebsiteProductColor.vue'
import KgjtWebsiteProductInfo from '@/componentsKgjt/KgjtWebsiteProductInfo.vue'
import KgjtWebsiteProductRecommend from '@/componentsKgjt/KgjtWebsiteProductRecommend.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    KgjtWebsiteProductEdit,
    KgjtWebsiteProductCharacteristics,
    KgjtWebsiteProductColor,
    KgjtWebsiteProductInfo,
    KgjtWebsiteProductRecommend
  },
  name: 'MyKgjtWebsiteProduct',
  data () {
    return {
      activeName: 'first',
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      categoriesList: [
        { value: '', label: '请选择产品分类' },
        { value: '智能变焦镜', label: '智能变焦镜' },
        { value: '护眼台灯', label: '护眼台灯' },
        { value: '护眼产品', label: '护眼产品' }
      ],
      isStarList: [
        { value: '1', label: '左上' },
        { value: '2', label: '左下' },
        { value: '3', label: '中间' },
        { value: '4', label: '右上' },
        { value: '5', label: '右下' },
        { value: '0', label: '不是明星产品' }
      ],
      isRecommendedList: [
        { value: '1', label: '爆款1' },
        { value: '2', label: '爆款2' },
        { value: '3', label: '爆款3' },
        { value: '4', label: '爆款4' },
        { value: '5', label: '爆款5' },
        { value: '6', label: '爆款6' },
        { value: '7', label: '爆款7' },
        { value: '0', label: '不是爆款推荐' }
      ],
      isList: [
        { value: '1', label: '是' },
        { value: '0', label: '否' }
      ],
      isFirstList: [
        { value: '1', label: '首推' },
        { value: '2', label: '次推' },
        { value: '0', label: '否' }
      ],
      // 查询客户
      keywords: {
        categories: '',
        name: ''
      },
      // 添加
      addData: {
        categories: '智能变焦镜',
        name: '',
        introduction: '',
        price: '',
        thumbnail1: '',
        thumbnail2: '',
        freedelivery: '1',
        details: '',
        isstar: '0',
        isrecommended: '0',
        isbest: '0',
        isfirst: '0'
      }
    }
  },
  mounted () {
    this.GetKgjtWebsiteErpProductNum()
    this.GetKgjtWebsiteErpProductList()
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
      this.GetKgjtWebsiteErpProductList()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.GetKgjtWebsiteErpProductList()
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.GetKgjtWebsiteErpProductNum()
      this.GetKgjtWebsiteErpProductList()
    },
    clickadd () {
      this.AddKgjtWebsiteErpProduct()
    },
    // 修改
    goEdit (row) {
      this.activeName = 'second'
      this.$refs.SubVuesecond.LoadData(row)
    },
    // 删除
    goDel (row) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.DelKgjtWebsiteErpProduct(row)
      })
    },
    // 产品特点
    goCharacteristics (row) {
      this.activeName = 'three'
      this.$refs.SubVuethree.LoadData(row)
    },
    // 产品颜色
    goColor (row) {
      this.activeName = 'four'
      this.$refs.SubVuefour.LoadData(row)
    },
    // 产品辅助信息
    goInfo (row, infotype) {
      this.activeName = 'five'
      this.$refs.SubVuefive.LoadData(row, infotype)
    },
    // 产品搭配
    goRecommend (row) {
      this.activeName = 'six'
      this.$refs.SubVuesix.LoadData(row)
    },
    GetKgjtWebsiteErpProductList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        categories: that.keywords.categories,
        name: that.keywords.name
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetKgjtWebsiteErpProductList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    GetKgjtWebsiteErpProductNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        categories: that.keywords.categories,
        name: that.keywords.name
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetKgjtWebsiteErpProductNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    AddKgjtWebsiteErpProduct: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        categories: that.addData.categories,
        name: that.addData.name,
        introduction: that.addData.introduction,
        price: that.addData.price,
        thumbnail1: that.addData.thumbnail1,
        thumbnail2: that.addData.thumbnail2,
        freedelivery: that.addData.freedelivery,
        details: that.addData.details,
        isstar: that.addData.isstar,
        isrecommended: that.addData.isrecommended,
        isbest: that.addData.isbest,
        isfirst: that.addData.isfirst
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddKgjtWebsiteErpProduct, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'

            that.addData.categories = '智能变焦镜'
            that.addData.name = ''
            that.addData.introduction = ''
            that.addData.price = ''
            that.addData.thumbnail1 = ''
            that.addData.thumbnail2 = ''
            that.addData.freedelivery = '1'
            that.addData.details = ''
            that.addData.isstar = '0'
            that.addData.isrecommended = '0'
            that.addData.isbest = '0'
            that.addData.isfirst = '0'

            that.GetKgjtWebsiteErpProductNum()
            that.GetKgjtWebsiteErpProductList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    DelKgjtWebsiteErpProduct: function (row) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: row.Id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DelKgjtWebsiteErpProduct, Qs.stringify(data))
        .then(function (response) {
          that.GetKgjtWebsiteErpProductNum()
          that.GetKgjtWebsiteErpProductList()
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 202px;
}

.optometry {
    margin-top: 15px;
    padding: 20px;
    background: #FAFAFA;
    border: 1px solid #EBEEF5;

    & ul{
        flex-wrap: wrap;
        margin: 0;
        padding: 0;

        & li{
            width: 35%;
            line-height: 28px;
            color: #606266;
            list-style: none;
        }
    }
}
.mt20{
   margin-top: 20px;
}
</style>
